import config from "./config"
import axios from 'axios'
import router from '../router/index'
import { ElMessage,ElLoading } from 'element-plus'
import { useStore } from 'vuex'
const store = useStore()
var params = {};
var token = "";
var lang = "";
var loading;

function getRequest(url,data,callback,loadingJudge) {
    if(localStorage.getItem('AutoToken')) {
        token = localStorage.getItem('AutoToken');
    }
    if(localStorage.getItem('language')) {
        lang = localStorage.getItem('language');
    }
    if(loadingJudge) {
        loading = ElLoading.service({
            lock: true
        })
    }
    axios({
        method: 'GET',
        url: config.BASE_API + url,
        headers: {
            token: token,
            lang: lang
        },
        params: Object.assign(data, params)
    }).then((res) => {
        if(loadingJudge) {
            loading.close();
        }
        if(res.data.code == '10020' || res.data.code == '10021') {
            router.push('/')
            store.commit('setMenuIndex', 0)
        } else if (res.data.code == '0') {
            typeof callback === 'function' && callback(res.data)
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}

function postRequest(url,data,callback,loadingJudge) {
    if(localStorage.getItem('AutoToken')) {
        token = localStorage.getItem('AutoToken');
    }
    if(localStorage.getItem('language')) {
        lang = localStorage.getItem('language');
    }
    let loading;
    if(loadingJudge) {
        loading = ElLoading.service({
            lock: true
        })
    }
    axios({
        method: 'POST',
        url: config.BASE_API + url,
        headers:{'content-type':'application/json',token: token,lang: lang},
        data: JSON.stringify(Object.assign(data, params))
    }).then((res) => {
        if(loadingJudge) {
            loading.close();
        }
        if(res.data.code == '10020' || res.data.code == '10021') {
            router.push('/')
            store.commit('setMenuIndex', 0)
        } else if (res.data.code == '0') {
            typeof callback === 'function' && callback(res.data)
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}

function putRequest(url,data,callback,loadingJudge) {
    if(localStorage.getItem('AutoToken')) {
        token = localStorage.getItem('AutoToken');
    }
    if(localStorage.getItem('language')) {
        lang = localStorage.getItem('language');
    }
    let loading;
    if(loadingJudge) {
        loading = ElLoading.service({
            lock: true
        })
    }
    axios({
        method: 'PUT',
        url: config.BASE_API + url,
        headers:{'content-type':'application/json',token: token,lang: lang},
        data: JSON.stringify(Object.assign(data, params))
    }).then((res) => {
        if(loadingJudge) {
            loading.close();
        }
        if(res.data.code == '10020' || res.data.code == '10021') {
            router.push('/')
            store.commit('setMenuIndex', 0)
        } else if (res.data.code == '0') {
            typeof callback === 'function' && callback(res.data)
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}

function deleteRequest(url,data,callback,loadingJudge) {
    if(localStorage.getItem('AutoToken')) {
        token = localStorage.getItem('AutoToken');
    }
    if(localStorage.getItem('language')) {
        lang = localStorage.getItem('language');
    }
    let loading;
    if(loadingJudge) {
        loading = ElLoading.service({
            lock: true
        })
    }
    axios({
        method: 'DELETE',
        url: config.BASE_API + url,
        headers:{'content-type':'application/json',token: token,lang: lang},
        data: JSON.stringify(Object.assign(data, params))
    }).then((res) => {
        if(loadingJudge) {
            loading.close();
        }
        if(res.data.code == '10020' || res.data.code == '10021') {
            router.push('/')
            store.commit('setMenuIndex', 0)
        } else if (res.data.code == '0') {
            typeof callback === 'function' && callback(res.data)
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}

export default {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
}

